import { createContext } from 'react'

const EnvelopeOverlayContext = createContext(false)

export default EnvelopeOverlayContext
